import * as React from "react";
const SvgArrowVcfc = props => <svg xmlns="http://www.w3.org/2000/svg" width={8} height={14} fill="none" viewBox="0 0 8 14" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 13 1 7l6-6" /></svg>;
export default SvgArrowVcfc;